// moz667: por culpa de vrdemo
var $ = jQuery;

window.autocomplete_init = function () {
    $("input.autocomplete-field").each(function () {
        var $autocomplete_field = $(this);

        var i = 1;
        var extra_params = {};

        while ($autocomplete_field.data("extra-param-inp-" + i)) {
            extra_params[$autocomplete_field.data("extra-param-inp-" + i)] = $autocomplete_field.data("extra-param-inp-" + i);
            i++;
        }

        i = 1;
        var get_params = {};

        while ($autocomplete_field.data("param-name-" + i)) {
            get_params[$autocomplete_field.data("param-name-" + i)] = $autocomplete_field.data("param-value-" + i);
            i++;
        }

        $autocomplete_field.autocomplete({
            minChars: 0,
            serviceUrl: $autocomplete_field.data("url"),
            noCache: true,
            onSelect: $autocomplete_field.data("on-select") ? eval($autocomplete_field.data("on-select")) : null,
            params: get_params,
            deferRequestBy: 100,
            extra_params: extra_params
        });
    });
}
